module.exports = __webpack_public_path__ + "03583eec8045939407f03a11487ab2ae.svg";